import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Formik, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import NewDesign from 'components/NewDesign';
import { isFunction } from 'lodash';

/**
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.toggle
 * @param {string} props.className
 * @param {'primary' | 'secondary' | 'danger' | 'success' | 'warning'} props.colorBtnSubmit
 * @param {(values, helpersFormik) => void} props.onSubmit
 * @param {any} props.header
 * @param {any} props.content
 * @param {Object} props.initialValues
 * @param {Object} props.validationSchema - Yup.object().shape({})
 * @param {string} props.labelBtnSubmit
 * @param {string} props.labelBtnClose
 * @param {'lg' | 'xl'} props.size
 * @param {Object} props.style
 * @param {boolean} props.disableFooter
 * @returns
 */
const ConfirmModal = ({
  isOpen,
  toggle,
  className,
  onSubmit,
  header = 'Default Header',
  content = 'Default Content modal',
  colorBtnSubmit = '',
  initialValues = {},
  validationSchema,
  labelBtnSubmit,
  labelBtnClose,
  size,
  style,
  disableFooter,
}) => {
  const { t } = useTranslation();

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, propsFormik) => onSubmit && onSubmit(values, { ...propsFormik, toggle })}
    >
      {(propsFormik) => (
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          className={className}
          backdrop={propsFormik.isSubmitting ? 'static' : true}
          size={size}
          style={style}
        >
          <Form>
            <ModalHeader toggle={toggle}>{header}</ModalHeader>

            <ModalBody>{isFunction(content) ? content(propsFormik) : content}</ModalBody>

            {!disableFooter && (
              <ModalFooter>
                <NewDesign.Button
                  type='submit'
                  color={colorBtnSubmit || 'primary'}
                  isLoading={propsFormik.isSubmitting}
                  colorSpinner='white'
                >
                  {labelBtnSubmit || t('shared:yes')}
                </NewDesign.Button>
                <button type='button' className='btn' onClick={toggle}>
                  {labelBtnClose || t('shared:close')}
                </button>
              </ModalFooter>
            )}
          </Form>
        </Modal>
      )}
    </Formik>
  );
};
export default ConfirmModal;
